import React, { useState } from 'react';
import { Button } from 'antd';
import UnionImage from '../../styles/images/Union.png';

/**
 * 空内容页组件
 * @param {Object} props - 组件属性
 * @param {string} props.image - 图片路径，默认为 Union.png
 * @param {string} props.title - 标题文字
 * @param {string} props.description - 描述文字
 * @param {React.ReactNode} props.children - 子组件，用于自定义内容
 * @param {Object} props.actions - 操作按钮配置
 * @param {string} props.actions.primary - 主要按钮文字
 * @param {Function} props.actions.onPrimary - 主要按钮点击事件
 * @param {string} props.actions.secondary - 次要按钮文字
 * @param {Function} props.actions.onSecondary - 次要按钮点击事件
 * @param {string} props.className - 自定义样式类名
 * @param {string} props.titleClassName - 标题自定义样式类名
 * @param {string} props.primaryButtonClassName - 主要按钮自定义样式类名
 */
const EmptyState = ({
  image = UnionImage,
  title = '这里空空如也',
  description,
  children,
  actions,
  className = '',
  titleClassName = 'text-gray-900',
  primaryButtonClassName = '',
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className={`flex flex-col items-center justify-center py-8 px-4 ${className}`}>
      {/* 图片区域 */}
      <div className="mb-8">
        <div className="relative">
          {!imageError ? (
            <img
              src={image}
              alt="空状态"
              className="w-32 h-32 object-contain"
              onError={handleImageError}
            />
          ) : (
            <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center">
              <div className="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 文字内容区域 */}
      <div className="text-center mb-8">
        {title && (
          <h3 className={`text-xl font-medium mb-3 ${titleClassName}`}>
            {title}
          </h3>
        )}
        {description && (
          <p className="text-sm text-gray-500 max-w-md mx-auto leading-relaxed">
            {description}
          </p>
        )}
        {children && (
          <div className="mt-4">
            {children}
          </div>
        )}
      </div>

      {/* 操作按钮区域 */}
      {actions && (
        <div className="flex gap-4">
          {actions.primary && (
            <Button
              type="primary"
              onClick={actions.onPrimary}
              className={`px-8 h-10 ${primaryButtonClassName}`}
              size="large"
            >
              {actions.primary}
            </Button>
          )}
          {actions.secondary && (
            <Button
              onClick={actions.onSecondary}
              className="px-8 h-10"
              size="large"
            >
              {actions.secondary}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
